import Produkt from "./Produkt";
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, MobileStepper, Theme, Typography } from "@material-ui/core";
import useWizardFormCtx from "../../ctx-provider/useWizardFormCtx";
import SwipeableViews from 'react-swipeable-views';
import BtnNext from "./BtnNext";
import IconForward from '@material-ui/icons/ArrowForwardIos';
import IconBack from '@material-ui/icons/ArrowBackIos';
import FlexNewLine from "../../../../cmp/flex/FlexNewLine";

// https://react-swipeable-views.com/demos/demos/

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        //display: 'flex',
        //justifyContent: 'center',
        //backgroundColor: 'red'
    },

    produktContainer: {
        display: 'flex',
        justifyContent: 'center'
    },

    iconButton: {
        //backgroundColor: theme.palette.secondary.main
    },

    stepper: {
        flexBasis: '60%',
        background: 'transparent',
        paddingTop: 0
    }
}));

const INDEX_MIT = 1;
const INDEX_OHNE = 0;

const Btn: React.FC<{ className: string, disabled?: boolean, onClick: () => void }> = ({ children, className, disabled, onClick }) => (
    <IconButton color="primary" aria-label="Produkt" size='small' className={className} disabled={disabled} onClick={onClick}>
        {children}
    </IconButton>
);

const BtnForward: React.FC<{ className: string, disabled?: boolean, onClick: () => void }> = ({ className, disabled, onClick }) => (
    <Btn className={className} disabled={disabled} onClick={onClick}><IconForward /></Btn>
);

const BtnBack: React.FC<{ className: string, disabled?: boolean, onClick: () => void }> = ({ className, disabled, onClick }) => (
    <Btn className={className} disabled={disabled} onClick={onClick}><IconBack /></Btn>
);

const ProduktDevMobile: React.FC<{ loading: boolean }> = ({ loading }) => {
    const classes = useStyles();
    const { wizardFormBo, fireWizardFormBo, handleNextPage } = useWizardFormCtx();
    const [activeStep, setActiveStep] = React.useState(wizardFormBo.angebot.produktMitSchutzbrief ? INDEX_MIT : INDEX_OHNE);

    const handleChangeIndex = (index: number) => {
        setActiveStep(index);

        wizardFormBo.angebot.produktMitSchutzbrief = INDEX_MIT === index;
        fireWizardFormBo(wizardFormBo);
    };

    const onClick = () => {
        handleNextPage();
    }

    return (
        <div className={classes.root}>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                <div>
                    <Typography color='primary' variant='body2'>Weitere Produkte</Typography>
                </div>
                <FlexNewLine />
                <MobileStepper
                    className={classes.stepper}
                    steps={2}
                    position="static"
                    variant="dots"
                    activeStep={activeStep}
                    backButton={<BtnBack className={classes.iconButton} disabled={activeStep === INDEX_OHNE}
                        onClick={() => handleChangeIndex(INDEX_OHNE)} />}

                    nextButton={<BtnForward className={classes.iconButton} disabled={activeStep === INDEX_MIT}
                        onClick={() => handleChangeIndex(INDEX_MIT)} />}
                />
            </div>
            <div style={{ marginTop: 10 }}>
                <SwipeableViews index={activeStep} onChangeIndex={handleChangeIndex}>
                    <div className={classes.produktContainer}>
                        <Produkt loading={loading} mobileVersion={true} active={true} mitSchutzbrief={false}
                            btn={<BtnNext onClick={onClick} />} infoOnly={false} />
                    </div>
                    <div className={classes.produktContainer}>
                        <Produkt loading={loading} mobileVersion={true} active={true} mitSchutzbrief={true}
                            btn={<BtnNext onClick={onClick} />} infoOnly={false} />
                    </div>
                </SwipeableViews>
            </div>
        </div >
    );
}

export default ProduktDevMobile;